module.exports = __webpack_public_path__ + "img/loading.14785b58.gif";